import ReactDOM from 'react-dom';
import { get } from 'lodash';

const appendExcludeButtons = newExcludeButton => {
    const thumbBlocks = document.querySelectorAll('.thumbBlock');
    thumbBlocks.forEach(block => {
        const parent = block.closest('.videoCube');
        const excludeButtonContainer = document.createElement('div');
        if (get(parent, ['video_data'], '')) {
            parent.appendChild(excludeButtonContainer);
            ReactDOM.render(newExcludeButton, excludeButtonContainer);
        }
    });
};

export default appendExcludeButtons;
